import { actionEqual } from './utils';
import * as ActionCreators from '../actions/ActionCreators';

// I think deprecated. Use favourite state instead
const defaultState: UserShopItemState = {
  shop_item_ids: [],
};

export default function userShopItems(
  state: UserShopItemState = defaultState,
  action: Action
): UserShopItemState {
  if (actionEqual(action, ActionCreators.receivedFetchUserShopItemAll)) {
    return {
      ...state,
      shop_item_ids: action.payload.shop_items.map(item => item.id).reverse(),
    };
  } else {
    return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/userShopItems.ts